<script lang="ts" setup>
import { DownOutlined } from '@ant-design/icons-vue'

const viewport = useViewport()

watch(() => viewport.breakpoint, (newBreakpoint, oldBreakpoint) => {
    console.log('Breakpoint updated:', oldBreakpoint, '->', newBreakpoint)
})
</script>

<template>
    <a-dropdown :trigger="['click']">
        <a 
            class="ant-dropdown-link flex items-center gap-[1rem] py-[.95rem] px-[1.6rem] border-solid border rounded-[.8rem] text-[primary] font-bold text-[1.4rem] cursor-pointer divide-[darkGray] hover:border-[darkGray] hover:bg-[bgSecond] transition ease-in-out delay-150 relative max-md:py-[.8rem] max-md:px-[1.2rem] max-md:text-[1.2rem] max-md:whitespace-nowrap"
            @click.prevent
        >
            My Account
            <DownOutlined v-if="viewport.isGreaterThan('sp')" />
        </a>
        <template #overlay>
            <a-menu>
                <slot />
            </a-menu>
        </template>
    </a-dropdown>
</template>
